import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies';
import { useLocation } from '@reach/router';

import { useLocalStorage } from '../../hooks/useLocalStorage';
import { useCallback, useEffect, useRef } from 'react';

export const CookieConsent = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const location = useLocation();

  const [bannerHidden, setBannerHidden] = useLocalStorage(
    'cookie_consent',
    false
  );

  const enableAnalytics = useCallback((enable: boolean) => {
    if (enable) {
      document.cookie = 'gatsby-gdpr-google-analytics=true;';
      document.cookie = 'gatsby-gdpr-google-tagmanager=true;';
      document.cookie = 'gatsby-gdpr-facebook-pixel=true;';
    }
    setBannerHidden(true);
  }, []);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;
    if (!bannerHidden) {
      timeoutId = setTimeout(() => {
        containerRef.current?.classList.add('active');
      }, 2000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [bannerHidden]);

  useEffect(() => {
    initializeAndTrack(location);
  });

  if (bannerHidden) {
    return null;
  }

  return (
    <div
      ref={containerRef}
      className="fixed bottom-4 left-4 right-4 md:right-auto grid gap-4 md:grid-flow-col md:gap-8 items-center p-4 bg-neutral-800 shadow-lg rounded-2xl delayed-animation fade-bottom"
    >
      <div className="flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          className="stroke-info flex-shrink-0 w-6 h-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
        <span className="ml-4">
          This website uses cookies to enhance the user experience.
        </span>
      </div>

      <div className="grid gap-2 grid-flow-col">
        <button
          className="btn btn-sm btn-ghost"
          onClick={() => enableAnalytics(false)}
        >
          Deny
        </button>
        <button
          className="btn btn-sm btn-primary"
          onClick={() => enableAnalytics(true)}
        >
          Accept
        </button>
      </div>
    </div>
  );
};
